module.exports = __webpack_public_path__ + "img/PCB CLEANING CONVEYOR.660e0209.jpg";